import { Link } from 'react-router-dom';

import DashboardActiveHeaderSession from './components/session';
import DashboardActiveHeaderDrivers from './components/drivers';
import DashboardActiveFlagAndRoad from './components/flag_road';
import DashboardActiveWeather from './components/weather';
import DashboardActiveAccount from './components/account';

function DashboardActiveHeader( {value, setCurrentDriver, currentDriver, setCurrentDriverUUID, userData} ) {

    return (
        <header className="flex h-16 items-center justify-between border-b border-[#233648] bg-background-light dark:bg-background-dark px-6 shrink-0">
            <div className="flex items-center gap-6">
                <Link to="/">
                    <div className="flex items-center gap-3">
                        <div className="size-8 bg-primary rounded flex items-center justify-center">
                            <span className="material-symbols-outlined text-white text-xl">speed</span>
                        </div>
                        <h1 className="text-xl font-bold tracking-tight text-white uppercase italic"><span className="text-primary">Live</span>Telemetry</h1>
                    </div>
                </Link>

                <DashboardActiveHeaderSession value={value}/>
            </div>

            <DashboardActiveHeaderDrivers setCurrentDriver={setCurrentDriver} currentDriver={currentDriver} setCurrentDriverUUID={setCurrentDriverUUID}/>

            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                    <DashboardActiveFlagAndRoad value={value}/>

                    <DashboardActiveWeather value={value}/>

                    <DashboardActiveAccount userData={userData}/>
                </div>
            </div>
        </header>
    );
}

export default DashboardActiveHeader;